import React from 'react'
import { useHistory } from 'react-router'
import { MdDeleteForever, MdEdit } from "react-icons/md"
export const QuotesList = () => {

    const history = useHistory()

    return (

        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-end mb-3">
                            <button className="btn btn-primary w-sm waves-effect waves-light mx-3"
                                onClick={() => history.push('add-quotes')}
                            >Add Quotes
                            </button>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>S no.</th>
                                        <th>Services</th>
                                        <th>Origin</th>
                                        <th>Destination</th>
                                        <th>Weight</th>
                                        <th>Volume</th>
                                        <th>Packages (No.)</th>
                                        <th>Customer Name</th>
                                        <th>Email</th>
                                        <th>Special Request</th>
                                        <th>Status</th>
                                        <th>Online Quote</th>
                                        <th>Courier Amount</th>
                                        <th>Action</th>



                                    </tr>
                                </thead>
                                <tbody>

                                    <tr>
                                        <td 
                                        // scope="row"
                                        >01</td>
                                        <td>SEA-DOOR</td>
                                        <td>India</td>
                                        <td>Dubai</td>
                                        <td>250kg</td>
                                        <td>0.052 M*3</td>
                                        <td>12</td>
                                        <td>lorem ipsum</td>
                                        <td>lorem@gmail.com</td>
                                        <td>lorem ipsum</td>
                                        <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Active</span> </td>
                                        <td>656.00</td>
                                        <td>656.00</td>
                                        <td>
                                            <MdEdit
                                                className="pointer"
                                                onClick={() => history.push('edit-quotes')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                            <MdDeleteForever
                                                // className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                                className="pointer"
                                                color="red"
                                                size="25px"
                                            // onClick={() => setDeleteModalOpen(item)}
                                            />
                                        </td>

                                    </tr>


                                    <tr>
                                        <td 
                                        // scope="row"
                                        >02</td>
                                        <td>SEA-DOOR</td>
                                        <td>India</td>
                                        <td>Dubai</td>
                                        <td>250kg</td>
                                        <td>0.052 M*3</td>
                                        <td>12</td>
                                        <td>lorem ipsum</td>
                                        <td>lorem@gmail.com</td>
                                        <td>lorem ipsum</td>
                                        <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Active</span> </td>
                                        <td>656.00</td>
                                        <td>656.00</td>
                                        <td>
                                            <MdEdit
                                                className="pointer"
                                                onClick={() => history.push('edit-quotes')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                            <MdDeleteForever
                                                // className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                                className="pointer"
                                                color="red"
                                                size="25px"
                                            // onClick={() => setDeleteModalOpen(item)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td 
                                        // scope="row"
                                        >03</td>
                                        <td>SEA-DOOR</td>
                                        <td>India</td>
                                        <td>Dubai</td>
                                        <td>250kg</td>
                                        <td>0.052 M*3</td>
                                        <td>12</td>
                                        <td>lorem ipsum</td>
                                        <td>lorem@gmail.com</td>
                                        <td>lorem ipsum</td>
                                        <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Active</span> </td>
                                        <td>656.00</td>
                                        <td>656.00</td>
                                        <td>
                                            <MdEdit
                                                className="pointer"
                                                onClick={() => history.push('edit-quotes')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                            <MdDeleteForever
                                                // className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                                className="pointer"
                                                color="red"
                                                size="25px"
                                            // onClick={() => setDeleteModalOpen(item)}
                                            />
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}
